<template>
  <div class="min-h-screen">
    <!-- Mobile sidebar backdrop -->
    <div v-if="sidebarOpen" class="fixed inset-0 z-40 lg:hidden" @click="sidebarOpen = false">
      <div class="fixed inset-0 bg-gray-600 bg-opacity-75" />
    </div>

    <!-- Mobile sidebar -->
    <Transition
      enter-active-class="transition-transform duration-300 ease-in-out"
      enter-from-class="-translate-x-full"
      enter-to-class="translate-x-0"
      leave-active-class="transition-transform duration-300 ease-in-out"
      leave-from-class="translate-x-0"
      leave-to-class="-translate-x-full"
    >
      <div v-if="sidebarOpen" class="fixed inset-y-0 left-0 z-50 w-64 cam shadow-xl lg:hidden">
        <Sidebar @close="sidebarOpen = false" />
      </div>
    </Transition>

    <!-- Desktop sidebar -->
    <div
      class="block lg:fixed lg:inset-y-0 lg:z-50 lg:flex lg:flex-col transition-all duration-300 ease-in-out"
      :class="sidebarWidth"
    >
      <Sidebar />
    </div>

    <!-- Main content area -->
    <div class="transition-all duration-300 ease-in-out" :class="mainContentPadding">
      <!-- <Header @toggle-sidebar="sidebarOpen = !sidebarOpen" /> -->

      <!-- Page content -->
      <main class="py-6">
        <div class="container mx-auto px-6">
          <!-- <Breadcrumbs v-if="showBreadcrumbs" class="mb-6" /> -->

          <!-- Page content -->
          <slot />
        </div>
      </main>
    </div>

    <!-- <NotificationContainer /> -->
  </div>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue'
import { useRoute } from 'vue-router'
import Sidebar from '@/components/layout/Sidebar.vue'
import { useSidebar } from '@/composables/useSidebar'

interface AppLayoutProps {
  showBreadcrumbs?: boolean
}

const props = withDefaults(defineProps<AppLayoutProps>(), {
  showBreadcrumbs: true,
})

const route = useRoute()
const { sidebarWidth, mainContentPadding } = useSidebar()
const sidebarOpen = ref(false)

// Hide breadcrumbs on certain routes
const showBreadcrumbs = computed(() => {
  if (!props.showBreadcrumbs) return false

  const hideBreadcrumbsRoutes = ['Login', 'ForgotPassword', 'ResetPassword', 'SelectOrganization']
  return !hideBreadcrumbsRoutes.includes(route.name as string)
})
</script>

<style scoped>
/* Ensure proper z-index stacking */
.sidebar-backdrop {
  z-index: 40;
}

.sidebar-mobile {
  z-index: 50;
}

.sidebar-desktop {
  z-index: 50;
}
</style>
